class AuthenticationApi {

    static loginWithToken(sanityToken) {
        return new Promise((resolve, reject) => {
            var req = new XMLHttpRequest();
            req.open('POST', process.env.REACT_APP_BASE_URL + '/api/Authentication/authenticatetoken?sanityToken=' + sanityToken, true);
            req.setRequestHeader('Content-Type', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Token non corretto');
                    } else {
                        reject('Errore sul server durante il tentativo di effettuare un login!');
                    }
                }
            };
            req.send();
        });
    }

    static loginSso(isakToken) {
        return new Promise((resolve, reject) => {
            var req = new XMLHttpRequest();
            req.open('POST', process.env.REACT_APP_BASE_URL + '/api/Authentication/authenticateSso?isakToken=' + isakToken, true);
            req.setRequestHeader('Content-Type', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Token non corretto');
                    } else {
                        reject('Errore sul server durante il tentativo di effettuare un login!');
                    }
                }
            };
            req.send();
        });
    }

    static login(loginModel) {
        return new Promise((resolve, reject) => {
            var req = new XMLHttpRequest();
            req.open('POST', process.env.REACT_APP_BASE_URL + '/api/Authentication/authenticateuser', true);
            req.setRequestHeader('Content-Type', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Username, password o ReCaptcha non corretti');
                    } else {
                        reject('Errore sul server durante il tentativo di effettuare un login!');
                    }
                }
            };
            req.send(JSON.stringify(loginModel));
        });
    }

    static logout(token) {
        return new Promise((resolve, reject) => {
            // DO Nothing maybe in the future call server
            resolve();
        });
    }

    static generateResetLink(model) {
        return new Promise((resolve, reject) => {
            var req = new XMLHttpRequest();
            req.open('POST', process.env.REACT_APP_BASE_URL + '/api/Authentication/generateResetLink', true);
            req.setRequestHeader('Content-Type', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('La tua richiesta non è corretta e non possiamo aiutarti per ragioni di sicurezza, contatta l\'Amministratore');
                    } else {
                        reject('Errore sul server durante il tentativo di effettuare un reset password!');
                    }
                }
            };
            req.send(JSON.stringify(model));
        });
    }

    static resetPassword(model) {
        return new Promise((resolve, reject) => {
            var req = new XMLHttpRequest();
            req.open('POST', process.env.REACT_APP_BASE_URL + '/api/Authentication/resetPassword', true);
            req.setRequestHeader('Content-Type', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        try {
                            const app = JSON.parse(req.response);
                            if (app.message)
                                reject(app.message);
                            else
                                reject('La tua richiesta non è corretta e non possiamo aiutarti per ragioni di sicurezza, contatta l\'Amministratore');
                        } catch (err) {
                            reject('La tua richiesta non è corretta e non possiamo aiutarti per ragioni di sicurezza, contatta l\'Amministratore');
                        }
                    } else {
                        reject('Errore sul server durante il tentativo di effettuare un reset password!');
                    }
                }
            };
            req.send(JSON.stringify(model));
        });
    }
}

export default AuthenticationApi;
